module.exports = __webpack_public_path__ + "img/11-Checkout-256.5ac3f17e.png";